import { combineReducers } from "redux";
import session from "./session";
import navigation from "./navigation";
import customer from "./customer";

export default combineReducers({ session, navigation, customer });
